import classnames from 'classnames';
import React, { useRef } from 'react';
import { useScaleCursor } from '@/utils/cursor-kit';

interface ScaleActionsProps {
    rotate: number;
}
const ScaleAction = (props: ScaleActionsProps) => {
    const { rotate } = props;
    const backSlashCursorNodeRef = useRef<HTMLSpanElement>(null);
    const slashCursorNodeRef = useRef<HTMLSpanElement>(null);
    const cursor = useScaleCursor(rotate);

    return (
        <div className="l-cropStage-scaleAction-img">
            <span ref={backSlashCursorNodeRef}>
                <div
                    className={classnames('vertex lt', {
                        [cursor.LT]: true,
                    })}
                    data-operate-type="crop-layer-scale-lt"
                />
                <div
                    className={classnames('vertex rb', {
                        [cursor.RB]: true,
                    })}
                    data-operate-type="crop-layer-scale-rb"
                />
            </span>

            <span ref={slashCursorNodeRef}>
                <div
                    className={classnames('vertex lb', {
                        [cursor.LB]: true,
                    })}
                    data-operate-type="crop-layer-scale-lb"
                />
                <div
                    className={classnames('vertex rt', {
                        [cursor.RT]: true,
                    })}
                    data-operate-type="crop-layer-scale-rt"
                />
            </span>
        </div>
    );
};

export default ScaleAction;
